import React, { memo } from "react";
import ProjectCard from "./ProjectCard";
import p1 from "../asset/p1.jpg";
import p3 from "../asset/p3.jpg";
import p4 from "../asset/p4.jpg";
import MobileProjectCard from "./MobileProjectCard";
import { useThemeColor } from "../hooks/useThemeColor";

const Section2 = memo(({ index, width, section2Ref, turnOnProject }) => {
  const themeColor = useThemeColor(index);
  const projectData = [
    {
      heading: "Movie Ticket Booking Website",
      skills: ["React", "Tailwind", "Zustand", "Mongodb"],
      img: p1,
      time: "2024",
      link: "https://inoxparadise.vercel.app",
      desc: "Inox Paradise is a MERN-based movie ticket booking site to search, review, and purchase tickets easily.",
    },
    {
      heading: "Links Vault",
      skills: ["NextJS", "Zustand", "Mongodb"],
      img: p3,
      time: "2024",
      link: "https://linksvault.vercel.app/",
      desc: "Effortlessly organize and categorize your links with AI-driven precision, making access and management simple and efficient.",
    },
    {
      heading: "Store Mate",
      skills: ["ReactJS", "Zustand", "Mongodb"],
      img: p4,
      time: "2024",
      link: "https://orrinstore.vercel.app/",
      desc: "Effortlessly manage inventory, track sales, and boost your business growth with our comprehensive shop management solution.",
    },
  ];
  return (
    <div
      ref={section2Ref}
      className=" w-full relative flex items-center flex-col gap-[1rem] py-[2rem]"
    >
      <h4
        className={`text-white tracking-[-5px] monospace ${width <= 768 ? "text-[10vw]" : "text-[70px]"}`}
      >
        Projects <span style={{ color: themeColor }}>highlight</span>
      </h4>
      {projectData.map((item, index) => {
        if (width > 768) {
          return (
            <ProjectCard
              key={index}
              title={item.heading}
              skills={item.skills}
              img={item.img}
              index={index}
              time={item.time}
              link={item.link}
            />
          );
        } else {
          return (
            <MobileProjectCard
              key={index}
              title={item.heading}
              index={index}
              link={item.link}
              skills={item.skills}
              img={item.img}
              desc={item.desc}
            />
          );
        }
      })}
      {/* <button
        onClick={() => {
          turnOnProject();
        }}
        className="border-[#727272] font-medium text-xs mt-4 border text-[#727272] px-4 py-1 rounded-md"
      >
        View More
      </button> */}
    </div>
  );
});

Section2.displayName = 'Section2';

export default Section2;
